import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center gap-4 mb-4",
  style: {
    "width": "750px"
  }
};
import { debounce } from 'lodash-es';
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import MediaTable from '../media/MediaTable.vue';
import { listMedia, listShopNews } from '../../api/media';
import useMedia from '../media/hooks/useMedia';
export default /*@__PURE__*/_defineComponent({
  __name: 'PublishResult',
  props: {
    item: {},
    content: {},
    isSummary: {
      type: Boolean
    },
    enableTrack: {
      type: Boolean
    },
    defaultTab: {}
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const info = ref({
      pubPlanDetails: []
    });
    const {
      approvalOptions
    } = useMedia();
    const activeTab = ref(props.defaultTab || '2');
    const searchData = ref({
      checkStatus: null,
      date: null,
      fromDate: null,
      toDate: null,
      title: ''
    });
    const dataRange = computed({
      get: () => [searchData.value.fromDate, searchData.value.toDate],
      set(value) {
        searchData.value.date = value || null;
        const [startDate, endDate] = value || [null, null];
        searchData.value.fromDate = startDate;
        searchData.value.toDate = endDate;
      }
    });
    const checkStatusOptions = [{
      label: '全部状态',
      value: null
    }, {
      label: '待审核',
      value: '0'
    }, {
      label: '发布中',
      value: '1'
    }, {
      label: '已发布',
      value: '2'
    }, {
      label: '已驳回',
      value: '-1'
    }, {
      label: '部分驳回',
      value: '3'
    }];
    const tabOptions = ref([{
      label: '权威媒体',
      value: '2',
      price: 400
    }, {
      label: '臻选媒体',
      value: '3',
      price: 20
    }, {
      label: '自媒体',
      value: '6',
      price: 20
    }, {
      label: '联盟新闻',
      value: '4',
      price: 10
    }, {
      label: '视频/图文',
      value: '9',
      price: 0
    }]);
    const haveDataTab = computed(() => {
      if (props.isSummary) {
        return tabOptions.value;
      }
      const have = [false, false, false, false];
      if (info.value.pubPlanDetails) {
        info.value.pubPlanDetails.forEach(item => {
          if (item.authoritativeMediaId) {
            have[0] = true;
          }
          if (item.selectedMediaIds && item.selectedMediaIds.length) {
            have[1] = true;
          }
          if (item.selfMediaIds && item.selfMediaIds.length) {
            have[2] = true;
          }
          if (item.newsSource) {
            have[3] = true;
          }
        });
      }
      const ret = [];
      for (let i = 0; i < have.length; i++) {
        if (have[i]) {
          ret.push(tabOptions.value[i]);
        }
      }
      return ret;
    });
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const pageIndex = ref(1);
    const pageSize = ref(10);
    // 获取列表数据
    const getList = () => {
      loading.value = true;
      const reset = {
        dataType: 1,
        mediaType: activeTab.value
      };
      if (!props.isSummary) {
        reset.geoMessageId = props.item.id;
        reset.geoFileIds = info.value.pubPlanDetails.map(item => item.articleFileId);
      }
      // 发布管理从权益明细进入时，按隐藏的原发布任务 ID 精确筛选；
      // 该参数只用于请求，不渲染到页面。
      if (props.isSummary && route.query.recordId) {
        reset.geoMessageId = String(route.query.recordId);
      }
      const func = activeTab.value == 4 ? listShopNews : listMedia;
      func({
        pageIndex: pageIndex.value,
        pageSize: pageSize.value,
        searchJsonData: {
          ...reset,
          ...searchData.value
        }
      }).then(res => {
        tableData.value = res.data.list || [];
        const {
          price
        } = tabOptions.value.find(item => item.value == activeTab.value);
        tableData.value.forEach(item => {
          item.useCount = ((item.Media || '').split(',').length - (item.pubFaildCount || 0)) * price;
          if (item.AuditStatus == -1) {
            // 驳回
            item.useCount = 0;
          }
          if (activeTab.value == 4) {
            // 联盟新闻
            if (item.AuditStatus == 1) {
              // 联盟新闻和其他不同 1就算已发布了
              item.AuditStatus = 2;
            }
          } else {}
        });
        total.value = res.data.recordsTotal;
      }).catch(() => {
        tableData.value = [];
        total.value = 0;
      }).finally(() => {
        loading.value = false;
      });
    };
    const handleTabChange = async tabName => {
      activeTab.value = tabName;
      pageIndex.value = 1;
      pageSize.value = 10;
      getList();
    };
    const handleSizeChange = val => {
      pageIndex.value = 1;
      pageSize.value = val;
      getList();
    };
    const handlePageChange = val => {
      pageIndex.value = val;
      getList();
    };
    const debounceGetList = debounce(getList, 300);
    watch(searchData, () => {
      debounceGetList();
    }, {
      deep: true
    });
    // 从权益明细跳转进入（带 recordId）时，流水类型可能对应多个子页签
    // （如 media3 同时覆盖自媒体与臻选媒体），实时查询各子页签，自动落在记录所在的页签。
    const locateRecordTab = async () => {
      const recordId = String(route.query.recordId || '');
      if (!props.isSummary || !recordId) return;
      const candidates = ['2', '3', '6', '4'];
      const results = await Promise.all(candidates.map(mediaType => {
        const func = mediaType === '4' ? listShopNews : listMedia;
        return func({
          pageIndex: 1,
          pageSize: 1,
          searchJsonData: {
            dataType: 1,
            mediaType,
            geoMessageId: recordId
          }
        }).catch(() => null);
      }));
      const hit = candidates.find((mediaType, index) => (results[index]?.data?.list || []).length);
      if (hit) activeTab.value = hit;
    };
    onMounted(async () => {
      try {
        if (props.content) {
          info.value = props.content;
          activeTab.value = haveDataTab.value.length ? haveDataTab.value[0].value : '2';
        }
        await locateRecordTab();
        getList();
      } catch (error) {
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => activeTab.value = $event),
        onTabChange: handleTabChange,
        class: "w-full"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(haveDataTab.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.value,
            label: item.label,
            name: item.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_date_picker, {
              modelValue: dataRange.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dataRange.value = $event),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
              modelValue: searchData.value.checkStatus,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchData.value.checkStatus = $event),
              placeholder: "全部",
              clearable: "",
              style: {
                "width": "160px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(checkStatusOptions, item => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: searchData.value.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchData.value.title = $event),
              style: {
                "width": "200px"
              },
              placeholder: "请输入标题",
              clearable: ""
            }, null, 8, ["modelValue"])]), _createVNode(MediaTable, {
              "is-summary": props.isSummary,
              "enable-track": props.enableTrack,
              "table-data": tableData.value,
              type: activeTab.value,
              "approval-options": _unref(approvalOptions),
              loading: loading.value,
              total: total.value,
              currentPage: pageIndex.value,
              pageSize: pageSize.value,
              onSizeChange: handleSizeChange,
              onPageChange: handlePageChange
            }, null, 8, ["is-summary", "enable-track", "table-data", "type", "approval-options", "loading", "total", "currentPage", "pageSize"])]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});